/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Faqlink1Inputs */

const he_contact_faqlink1 = /** @type {(inputs: Contact_Faqlink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דף השאלות הנפוצות`)
};

const en_contact_faqlink1 = /** @type {(inputs: Contact_Faqlink1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ page`)
};

/**
* | output |
* | --- |
* | "FAQ page" |
*
* @param {Contact_Faqlink1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_faqlink1 = /** @type {((inputs?: Contact_Faqlink1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Faqlink1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_faqlink1(inputs)
	return en_contact_faqlink1(inputs)
});
export { contact_faqlink1 as "contact_faqLink" }